"use strict";

var userId = "",
  lastId = "0",
  sharingSura = "0",
  sharingQuranViewSura = "0",
  sharingQuranViewSuraName = "",
  dataId = "0",
  dataIdID = "0",
  ayatRelations = [],
  userBookmarks = [],
  country_code = [],
  userReadingBookmark = "",
  bookmarkString = "",
  firebaseNode = "QM_Android_User_Bookmarks_Debug",
  currentScript = "IndoPak";
var istranslation = !!localStorage.getItem("transalatedView") && localStorage.getItem("transalatedView");
var selectionOfScriptNo = 9,
  fontfolderName = "data",
  count = 0,
  suraClickedCheck = !1,
  totalAyaat = [1, 8, 294, 494, 670, 790, 955, 1161, 1236, 1365, 1474, 1597, 1708, 1751, 1803, 1902, 2030, 2141, 2251, 2349, 2484, 2596, 2674, 2792, 2856, 2933, 3160, 3253, 3341, 3410, 3470, 3504, 3534, 3607, 3661, 3706, 3789, 3971, 4059, 4134, 4219, 4273, 4326, 4415, 4474, 4511, 4546, 4584, 4613, 4631, 4676, 4736, 4785, 4847, 4902, 4980, 5076, 5105, 5127, 5151, 5164, 5178, 5189, 5200, 5218, 5230, 5242, 5272, 5324, 5376, 5420, 5448, 5476, 5496, 5552, 5592, 5623, 5673, 5713, 5759, 5801, 5830, 5849, 5885, 5910, 5932, 5949, 5968, 5994, 6024, 6044, 6059, 6080, 6091, 6099, 6107, 6126, 6131, 6139, 6147, 6158, 6169, 6177, 6180, 6189, 6194, 6198, 6205, 6208, 6214, 6217, 6222, 6226, 6231, 6237],
  session_url_local = "http://localhost:3002",
  backend_url_local = api_Url,
  modalUrl = file_path,
  c_code = "PK",
  isArabicCountry = !1;
var highlightAyaNo,
  highlightSuraNo,
  suraButtonClick = (console.log(app_version), "local" == node_env && (console.log(node_env), console.log(file_path), console.log(api_Url)), 0);
var session_url_server = "https://quranmajeed.com",
  local_server = location.origin + base_path,
  scrollAllowed = !0,
  seletedVal = (counrtyCodeRelation().then(function (e) {
    var o,
      a = Intl.DateTimeFormat().resolvedOptions().timeZone.toLowerCase();
    for (o in country_code = [], e) country_code.push(e[o]);
    for (var t = 0; t <= country_code.length - 1; t++) if (country_code[t][0] == a) {
      c_code = country_code[t][1];
      break;
    }
    "SA" != c_code && "EG" != c_code && "IQ" != c_code && "JO" != c_code && "DZ" != c_code && "MA" != c_code && "AE" != c_code && "SD" != c_code && "TN" != c_code && "KW" != c_code && "SY" != c_code && "JO" != c_code && "YE" != c_code && "QA" != c_code && "BH" != c_code || (isArabicCountry = !0);
  }), JSON.parse(localStorage.getItem("seletedQuranFont")));
null == seletedVal ? 1 == isArabicCountry && (currentScript = "Uthmanic", selectionOfScriptNo = 5, fontfolderName = "dataUsmani") : null != seletedVal && (currentScript = seletedVal[0], selectionOfScriptNo = seletedVal[1], fontfolderName = seletedVal[2]);